import firebase from "firebase/compat/app"; //v9
import "firebase/compat/auth"; //v9

export const Firebase = () => {
  let auth;

  const initFirebase = async () => {
    const configObj = await (await fetch("/__/firebase/init.json")).json();
    firebase.initializeApp(configObj);
    auth = firebase.auth();
  };

  const getAuth = () => auth;

  const callFn = async (fn, data = {}) => {
    const token = await auth?.currentUser?.getIdToken();
    const headers = {
      "Content-Type": "application/json",
    };
    token && (headers.Authorization = `Bearer ${token}`);
    const res = await fetch(`${window.location.origin}/fns/${fn}`, {
      headers,
      method: "post",
      body: JSON.stringify({ data }),
    });
    const json = await res.json();
    if (res.status >= 200 && res.status <= 299) {
      return json;
    }
    throw new Error(json.error.message);
  };

  const doSignInWithEmailAndPassword = async (email, password) => {
    return auth.signInWithEmailAndPassword(email, password);
  };

  const doSignOut = async () => {
    return auth.signOut();
  };

  const getProfileByEmail = async (email) => {
    const { result } = await callFn("profiles-getProfileByEmail", { email });
    return result;
  };

  const adminGetUserByEmail = async (email) => {
    const { result } = await callFn("admin-getUserByEmail", { email });
    return result;
  };

  const getCompanyById = async (id) => {
    const { result } = await callFn("companies-getCompanyById", { id });
    return result;
  };

  const getAPPermsByUser = async (profileId) => {
    const { result } = await callFn("adminPortalPerms-getAPPermsByUser", { profileId });
    return result;
  };

  const getDocs = async () => {
    const { result } = await callFn("docs-getDocs", {});
    return result;
  };

  return {
    initFirebase,
    getAuth,
    doSignInWithEmailAndPassword,
    doSignOut,
    getProfileByEmail,
    adminGetUserByEmail,
    getCompanyById,
    getAPPermsByUser,
    getDocs,
  };
};
